export const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Media may be an absolute URL (pasted) or a backend-relative path (uploaded).
export const resolveMedia = (u) =>
  !u ? "" : u.startsWith("http") ? u : `${BACKEND}${u}`;

const TOKEN_KEY = "aidept_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export async function getJSON(path) {
  const r = await fetch(`${BACKEND}/api${path}`);
  if (!r.ok) throw new Error(`Request failed: ${r.status}`);
  return r.json();
}

// Fire-and-forget demo-open tracking. Never blocks or throws in the UI.
export function logDemoOpen({ agent, agentKey, industry, mode }) {
  try {
    fetch(`${BACKEND}/api/demo-events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        agent,
        agent_key: agentKey || "",
        industry: industry || "",
        mode: mode || "video",
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* no-op */
  }
}

export async function adminFetch(path, { method = "GET", body, isForm } = {}) {
  const headers = { Authorization: `Bearer ${getToken()}` };
  if (!isForm) headers["Content-Type"] = "application/json";
  const r = await fetch(`${BACKEND}/api${path}`, {
    method,
    headers,
    body: isForm ? body : body ? JSON.stringify(body) : undefined,
  });
  if (r.status === 401) {
    clearToken();
    throw new Error("unauthorized");
  }
  if (!r.ok) {
    const e = await r.json().catch(() => ({}));
    throw new Error(e.detail || `Request failed: ${r.status}`);
  }
  return r.json();
}
